<script setup>
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  label: { type: String, default: '' },
  helper: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const toggle = () => {
  if (props.disabled) return;
  emit('update:modelValue', !props.modelValue);
};
</script>

<template>
  <button
    type="button"
    class="flex w-full items-start justify-between gap-3 rounded-lais border px-3 py-3 text-left transition-colors"
    :class="
      modelValue
        ? 'border-lais-primary bg-lais-primary-50/70'
        : 'border-lais-border bg-white hover:border-lais-primary/40'
    "
    :disabled="disabled"
    @click="toggle"
  >
    <span class="flex min-w-0 flex-col">
      <span v-if="label" class="text-[13px] font-semibold text-lais-text">
        {{ label }}
      </span>
      <span
        v-if="helper"
        class="mt-1 text-[12px] leading-relaxed text-lais-text-muted"
      >
        {{ helper }}
      </span>
    </span>
    <span
      class="mt-0.5 inline-flex h-6 w-11 shrink-0 items-center rounded-full px-1 transition-colors"
      :class="modelValue ? 'bg-lais-primary' : 'bg-slate-300'"
    >
      <span
        class="size-4 rounded-full bg-white transition-transform"
        :class="modelValue ? 'translate-x-5' : 'translate-x-0'"
      />
    </span>
  </button>
</template>
